import { createContext } from 'react';

export const PDFUIInstanceContext = createContext();

export const PDFUIRenderToElementContext = createContext();